import type { StyleLayer } from './utils/types'

export const layers_placescircle: StyleLayer[] = [
  {
    id: 'circle-place-circle',
    type: 'circle',
    filter: ['match', ['get', 'place'], ['village', 'city', 'town'], true, false],
    paint: {
      'circle-color': 'rgba(255, 255, 255, 0.09)',
      'circle-radius': ['match', ['get', 'place'], ['city'], 15, ['town'], 7, ['village'], 3, 5],
      'circle-stroke-color': '#7304cd',
      'circle-stroke-opacity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        9.8,
        ['match', ['get', 'place'], ['city', 'town'], 1, 0],
        10,
        ['match', ['get', 'place'], ['city', 'town', 'village'], 1, 0],
      ],
      'circle-stroke-width': ['match', ['get', 'place'], ['city', 'town'], 2, 1.5],
    },
  },
  {
    id: 'circle-place-names',
    type: 'symbol',
    filter: ['match', ['get', 'place'], ['town', 'village', 'city'], true, false],
    minzoom: 9,
    layout: {
      'icon-allow-overlap': true,
      'icon-padding': 0,
      'icon-size': [
        'match',
        ['get', 'population'],
        ['6452'],
        3,
        ['8945'],
        4,
        ['10633', '11355'],
        5,
        ['17017'],
        8,
        ['38111'],
        19,
        1,
      ],
      'text-anchor': 'top',
      'text-field': [
        'step',
        ['zoom'],
        ['to-string', ['get', 'name']],
        10,
        ['to-string', ['concat', ['get', 'name'], ' \n ', ['get', 'population']]],
      ],
      'text-font': ['Open Sans SemiBold', 'Arial Unicode MS Regular'],
      'text-max-width': 20,
      'text-offset': [0, 1],
      'text-padding': 0,
      'text-size': ['interpolate', ['linear'], ['zoom'], 10, 9, 22, 13],
    },
    paint: {
      'text-color': '#594f4f',
      'text-halo-color': 'hsla(0, 6%, 97%, 0.91)',
      'text-halo-width': 1,
      'text-opacity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        9,
        ['match', ['get', 'place'], ['city', 'town'], 1, 0],
        10,
        ['match', ['get', 'place'], ['city', 'town'], 1, 0],
        11,
        ['match', ['get', 'place'], ['city', 'town', 'village'], 1, 0],
      ],
    },
  },
]
